module.exports = __webpack_public_path__ + "img/logo-lfb-couleur.2760ead7.webp";